import React, { FunctionComponent } from "react";
import { PaymentPage } from "./component";

export const PaymentPageContainer: FunctionComponent = () => {
  return <PaymentPage />;
};
